import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Avatar,
  Typography,
  Grid,
  Menu,
  MenuItem,
  IconButton
} from '@material-ui/core';
import styled from 'styled-components';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import axios from 'axios';
import Swal from 'sweetalert2';

const ITEM_HEIGHT = 48;

export default ({ 
  comment={}, 
  userId='',
  groupMemberStatus,
  getComments=()=>{},
  customTheme,
  ...props 
}) => {
  const Heart = ({
    isActive,
    onClick = () => {},
    animationTrigger = "click",
    animationScale = 1.05,
    animationDuration = 0.05,
    inactiveColor = "black",
    activeColor = "red",
    className,
    style
  }) => {
    return /*#__PURE__*/React.createElement(Svg, {
      onClick: () => onClick(),
      viewBox: "0 0 17 17",
      className: className,
      animationTrigger: animationTrigger,
      animationDuration: animationDuration,
      animationScale: animationScale,
      style: {
        fill: isActive ? activeColor : "transparent",
        stroke: isActive ? "transparent" : inactiveColor,
        strokeWidth: "1px",
        ...style
      },
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
    }));
  }
  const Svg = styled.svg`cursor: pointer;${props => {
    if (props.animationTrigger === "hover") return `transition: transform ${props.animationDuration}s; &:hover { transform: scale(${props.animationScale});}`;else if (props.animationTrigger === "click") return `transition: transform ${props.animationDuration}s; &:active { transform: scale(${props.animationScale});}`;else if (props.animationTrigger === "both") return `transition: transform ${props.animationDuration}s; &:hover { transform: scale(${props.animationScale});} &:active { transform: scale(${Math.pow(props.animationScale, 2)});}`;
  }});`;

  const [anchorEl, setAnchorEl] = useState(null);
  const [reactions, setReactions] = useState([]);
  const open = Boolean(anchorEl);
  // useEffect
  useEffect(() => {
    getCommentLikes();
  }, []);

  // get comment likes
  const getCommentLikes = async () => {
    const { data } = await axios.get(`/api/group-comment-like/${comment?._id}`);
    if (data) {
      setReactions(data);
    }
  };
  // post comment like
  const postCommentLike = async () => {
    const { data } = await axios.post('/api/group-comment-like', {
      userId,
      groupCommentId: comment?._id
    });
    if (data) {
      await getCommentLikes();
    }
  }
  // delete comment like
  const deleteCommentLike = async likeId => {
    const { data } = await axios.delete(`/api/group-comment-like/${likeId}`);
    if (data) {
      await getCommentLikes();
    }
  }

  // report comment (send comment to backend - fire email to hello@iternal.life)
  const reportComment = async () => {
    const { data } = await axios.post('/api/report-group-comment', {
      userId,
      groupCommentId: comment?._id,
    });
    Swal.fire({
      type: 'success',
      title: 'Your report has been received',
      text: 'Our team will look into this, thank you for flagging this comment for us.'
    });
  }

  // delete comment
  const deleteComment = async () => {
    const { data } = await axios.delete(`/api/group-memory-comments/${comment?._id}`);
    if (data) {
      await getComments();
      Swal.fire({
        type: 'success',
        title: 'The comment was deleted'
      })
    }
  }

  // edit comment


  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container>
      <Grid item xs={2} sm={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',
      }}>
        <Avatar
          src={
            comment?.profilePicture?.imagePath || ''
         
          }
          alt="Your profile avatar"
          style={{
            maxHeight: '100%',
            maxWidth: '100%',
            height: '2.5rem',
            width: '2.5rem',
            backgroundColor: customTheme.palette.primary.light,
            color: customTheme.palette.primary.contrastText, 
            textTransform: 'capitalize'
          }}
        >
           {comment?.name[0]}
        </Avatar>
      </Grid>
      <Grid item xs={10} sm={9} md={10}>
        <Typography variant='body1' style={{fontSize:'0.9rem', marginRight: '1rem', marginLeft:'1rem', marginTop:'0.25rem'}}>
          {comment?.text}
        </Typography>
        <Typography variant='body2' style={{fontSize:'0.8rem', marginLeft:'1rem'}}>
          <span style={{ color: 'var(--neutral-mist)' }}>
            {comment?.name}
          </span>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={2} md={1} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center' }}>
        <div style={{ width: "1rem", display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '0.25rem' }}>
          <Heart
          style={{width:'20px'}}
            isActive={
              reactions.filter(reaction => reaction.userId === userId)
                .length > 0
            }
            onClick={async () => {
              const hasReacted = reactions.filter(
                reaction => reaction.userId === userId,
              );
              if (hasReacted && hasReacted.length > 0) {
                await deleteCommentLike(hasReacted[0]?._id);
              } else {
                await postCommentLike();
              }
            }}
          
            animationScale={1.2}
            animationTrigger="both"
            animationDuration={0.2}
            className={`heartContainer${reactions.filter(reaction => reaction.userId === userId).length > 0 ? ' active' : ''}`}
          />
        </div>
        <IconButton
          onClick={handleMenuClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          }}
        >
          {(userId === comment.userId || groupMemberStatus === 'owner' || groupMemberStatus === 'admin') && (
            <MenuItem 
              key={'Delete'} 
              onClick={async event => {
                await deleteComment();
                handleMenuClose(event);
              }}
            >
              Delete
            </MenuItem>
          )} 
          <MenuItem 
            key={'Report'}               
            onClick={async event => {
              await reportComment();
              handleMenuClose(event);
            }}
          >
            Report
          </MenuItem>
        </Menu>
      </Grid>
    </Grid>
  )
};

// Divider.propTypes = {
//   /**
//    * Would you like to include the Iternal Logo in this divider?
//    */
//   logo: PropTypes.bool,
//   /**
//    * What text should this divier have?
//    */
//   text: PropTypes.string,
//   /**
//    * How opaque should the divider be?
//    */
//   opacity: PropTypes.number,
// };

// Divider.defaultProps = {
//   logo: false,
//   text: undefined,
//   opacity: 0.2,
// };
